import { Expose } from 'class-transformer';
import { BasicData } from '../basic/BasicData';
import { Point } from './Point';

export class Mission extends BasicData {
    static readonly ModelFeatureAttribute = {
        CLASS_NAME: 'Mission',
    };

    @Expose()
    droneId: string = '';

    @Expose()
    title: string = '';

    @Expose()
    description: string = '';

    @Expose()
    coordinates: [][] = [];

    @Expose()
    createdAt: string = '';

    @Expose()
    modifiedAt: string = '';

    @Expose()
    steps: Point[] = [];
}
